export const load = () => ({
	title: 'This Old House Charleston and Indow',
	showTitle: true,
});
